import { useIsNLPCollegeSearchEnabled } from 'store/feature-toggle/hooks'

import { types } from '../../../../../AwesomeBar'
import ResultComponent from './ResultComponent'

export const label = 'nlp'

export const useNlpSearchConfig = (): types.ISearchConfiguration => {
  const isNLPCollegeSearchEnabled = useIsNLPCollegeSearchEnabled()
  return {
    label,
    search: (searchTerm: string) => Promise.resolve([{ label: searchTerm, searchTypeLabel: label }]),
    ResultComponent,
    hidden: !isNLPCollegeSearchEnabled,
    hideTab: true,
  }
}
